module.exports = __webpack_public_path__ + "media/andenes/montacargas-3bccf7e7.webp";